// src/portals/fan/components/CreatorPreviewCard.js
import React from "react";
import { Link } from "react-router-dom";

const CreatorPreviewCard = ({ creator }) => {
  return (
    // THE FIX: The 'to' prop now correctly points to the route inside the Fan Portal
    <Link
      to={`/fan/creator/${creator.username}`}
      className="flex-shrink-0 w-20 flex flex-col items-center gap-2 group"
    >
      <div className="relative">
         {/* Premium Story Ring (Instagram-style gradient) */}
         <div className="absolute -inset-0.5 bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 rounded-full opacity-0 group-hover:opacity-100 transition duration-300"></div>
         
         {/* Main Picture with standard shadow */}
         <div className="relative p-0.5 bg-white rounded-full shadow-md group-hover:shadow-none transition-all">
           <img
             src={creator.profilePictureUrl}
             alt={creator.name}
             className="w-16 h-16 rounded-full object-cover bg-slate-100"
           />
         </div>
      </div>
      
      <p className="text-[11px] font-bold text-center truncate w-full text-slate-800 tracking-tight">
        {creator.name}
      </p>
    </Link>
  );
};

export default CreatorPreviewCard;
